import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant.js';
export const AI_VOICE_CLONE_USE_CREDIT = 5;
export const FJSliceVoiceCloning = createSlice({
    name: 'VoiceCloning',
    initialState: {
        profileId: 'default',
        voiceName: '',
        selectedLang: 'en',
        audioUrl: '',
        audioBlob: '',
        audioName: '',
        createCloneStatus: FJConstant.DEFAULT,
        isUploading: false,
        isShowVoiceEditModal: false,
        voiceCloneEditProfileId: 'default',
        voiceCloneEditName: '',
        previewAudioUrl: '',
    },
    reducers: {
        setProfile: (state, action) => {
            state.profileId = action.payload;
        },
        setVoiceName: (state, action) => {
            state.voiceName = action.payload;
        },
        setSelectedLang: (state, action) => {
            state.selectedLang = action.payload;
        },
        setAudioUrl: (state, action) => {
            state.audioUrl = action.payload;
        },
        setAudioBlob: (state, action) => {
            state.audioBlob = action.payload;
        },
        setCreateCloneStatus: (state, action) => {
            state.createCloneStatus = action.payload;
        },
        setAudioName: (state, action) => {
            state.audioName = action.payload;
        },
        setIsShowVoiceEditModal: (state, action) => {
            state.isShowVoiceEditModal = action.payload;
        },
        setVoiceCloneEditProfileId: (state, action) => {
            state.voiceCloneEditProfileId = action.payload;
        },
        setVoiceCloneEditName: (state, action) => {
            state.voiceCloneEditName = action.payload;
        },
        setPreviewAudioUrl: (state, action) => {
            state.previewAudioUrl = action.payload;
        },
        setIsUploading: (state, action) => {
            state.isUploading = action.payload;
        },
    },
});

export const {
    setProfile,
    setVoiceName,
    setSelectedLang,
    setAudioUrl,
    setAudioBlob,
    setCreateCloneStatus,
    setAudioName,
    setIsShowVoiceEditModal,
    setVoiceCloneEditProfileId,
    setVoiceCloneEditName,
    setPreviewAudioUrl,
    setIsUploading,
} = FJSliceVoiceCloning.actions;

export default FJSliceVoiceCloning.reducer;
